import React, { Component } from "react";
import { createPortal } from "react-dom";
import { connect } from "react-redux";
import { Redirect } from "react-router";

import { enBrowserType } from "../lib/ConstCommand";
import { cancelTimer, initializeTimer } from "../lib/TimeOutAlert";
import { get_class_monitor_use, update_class_monitor_use } from "../lib/api/user";

import {
    changeFalseToGotoLiveList
} from "../modules/chat";

import {
    callRequestAssignUser,
    callCancelRequestAssignUser,
    callClearAssignUser
} from "../modules/studio";

import {
    checkCode,
    createCode,
    createLive,
    stopLive,
    onAirLive,
    offTheAirLive,
    activeHandsUp,
    inactiveHandsUp,
    joinMyBroadcastLive,
    updateLiveMember,
    updateLiveGroupLimit,
    updateLiveName,
    updatePublicYnForLocalLive,
    requestUpdateMixedClassExistYn,
    notifyLiveBroadcast,
    notifyLiveBroadcastWithGuest,
    getMixedClassMailInfo,
    requestUpdateMixedClassStatus,
    changeFalseToCertifiedLiveCode,
    handsupOpenToggle,
    openGroupStudyWindow,
    closeGroupStudyWindow,
    searchLiveListResult,
    setMessageString,
    clearPendingAutoOnAir,
    closeModal,
    closeErrorAlertModal,
    flaseToInitTimer,
    falseToCertifiedLiveCode,
    toggleBroadcastTimeNotify,
    toggle_sendMixedClassLink,
    toggle_createBroadcastLive,
    toggle_notifyLiveBroadcast,
    toggle_offAirBroadcastLive,
    toggle_showBroadcastLiveMember,
    toggle_configBroadcastLiveList,
    toggle_configLocalBroadcastLive,
    toggle_searchBroadcastLiveList,
} from "../modules/live";

import {
    initGroupChat,
    clearGroupChat,
    closeGroupChatPopup,
} from "../modules/groupChat";

import ConfigMyBroadcastLiveListContainer from "./live/ConfigMyBroadcastLiveListContainer";
import MyBroadcastLiveListContainer from "./live/MyBroadcastLiveListContainer";

import SearchLiveList from "../components/live/modal/SearchLiveList";
import CreateLive from "../components/live/modal/CreateLive";
import BroadcastLiveMember from "../components/live/modal/BroadcastLiveMember";
import OffAirLive from "../components/live/modal/OffAirLive";
import NotifyLiveBroadcast from "../components/live/modal/NotifyLiveBroadcast";
import SendMixedClassLink from "../components/live/modal/SendMixedClassLink";
import ConfigLocalLive from "../components/live/modal/ConfigLocalLive";

import RightSideModal from "../components/template/modal/RightSideModal";
import ToppedModal from "../components/template/modal/ToppedModal";
import CenteredModal from "../components/template/modal/CenteredModal";
import AlertErrorModal from "../components/live/modal/AlertErrorModal";

class BroadcastLiveListContainer extends Component {
    componentDidMount() {
        if (this.props.isGotoLiveList) {
            this.props.changeFalseToGotoLiveList();
        }

        if (this.props.isConfigLiveListModalOpened) {
            this.props.closeModal("NONE");
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.list_live !== this.props.list_live) {
            let selectedLive = this.props.list_live.find(live => live.selectStatus === "Y");
            console.log("componentDidUpdate - ", selectedLive);
            if (selectedLive && selectedLive.liveSeq !== undefined) {
                this.props.initGroupChat({ liveSeq: selectedLive.liveSeq, list_member: selectedLive.list_member });
            } else {
                this.props.closeGroupChatPopup();
                this.props.clearGroupChat();
            }
        }
    }

    handleSearchValue = ({ keyword }) => {
        console.log("handleSearchValue - keyword => ", keyword);
        let newKeyword = keyword.toLowerCase();
        console.log("handleSearchValue - newKeyword => ", newKeyword);

        try {
            let result = this.props.list_live.filter((live) => {
                return live.liveName.toLowerCase().indexOf(newKeyword) > -1;
            });

            console.log("handleSearchValue - result => ", result);

            this.props.searchLiveListResult({ result });
        } catch (err) {
            console.log("handleSearchValue() - err => ", err);
        }
    }

    handleSelectedFunc = ({ selectedFunc, liveSeq, liveName, liveCode, list_member, memberSeq, studioSeq, groupLimit, data, list_broadcast, message }) => {
        switch (selectedFunc) {
            case "GO_TO_LIVE_PAGE":
                console.log("BroadcastLiveListContainer handleSelectedFunc - selectedFunc is GO_TO_LIVE_PAGE!!!!! go to live page!!!");
                this.props.routeProps.history.push(`/live/${liveSeq}`);
                break;

            case "NONE":
                // console.log("none");
                this.props.closeModal(selectedFunc);
                break;

            case "SEARCH":
                this.props.toggle_searchBroadcastLiveList(selectedFunc);
                break;

            case "CONFIG":
                this.props.toggle_configBroadcastLiveList(selectedFunc);
                break;

            case "EDIT_LOCAL_LIVE":
                this.props.toggle_configLocalBroadcastLive({ selectedFunc, liveSeq, open: true });
                break;

            case "NOTIFY":
                this.props.toggle_notifyLiveBroadcast(selectedFunc);
                break;

            case "NOTIFY_OK":
                if (data.list_guest && data.list_guest.length > 0) {
                    this.props.notifyLiveBroadcastWithGuest({
                        selectedFunc,
                        liveSeq,
                        userSeq: this.props.userSeq,
                        data,
                        mode: "hiclass"
                    });
                } else {
                    this.props.notifyLiveBroadcast({
                        selectedFunc,
                        liveSeq,
                        userSeq: this.props.userSeq,
                        data,
                        mode: "hiclass"
                    });
                }
                break;

            case "SEND_MIXED_CLASS_MAIL":
                this.props.toggle_sendMixedClassLink(selectedFunc);
                break;

            case "SEND_MIXED_CLASS_MAIL_OK":
                this.props.getMixedClassMailInfo({
                    selectedFunc,
                    localLiveSeq: liveSeq,
                    userNickname: this.props.userNickname,
                    liveName
                });
                break;

            case "JOIN":
                console.log("BroadcastLiveListContainer handleSelectedFunc - selectedFunc is JOIN!!!!! join my broadcast live!!!");
                this.props.joinMyBroadcastLive({
                    liveSeq,
                    userSeq: this.props.userSeq,
                    userNickname: this.props.userNickname,
                    liveName
                });
                break;

            case "GET_CODE":
                this.props.createCode({
                    mode: "hiclass"
                });
                break;

            case "GET_CODE_WEB":
                this.props.createCode({
                    mode: "web"
                });
                break;

            case "CHECK":
                this.props.checkCode({
                    liveCode,
                    mode: "hiclass"
                });
                break;

            case "CHECK_WEB":
                this.props.checkCode({
                    liveCode,
                    mode: "web"
                });
                break;

            case "CREATE":
                this.props.toggle_createBroadcastLive(selectedFunc);
                break;

            case "CREATE_OK":
                this.props.createLive({
                    chatRoomSeq: this.props.performChatRoomInfo.chatRoomSeq,
                    teacherSeq: this.props.userSeq,
                    liveName,
                    liveCode,
                    mode: "hiclass"
                });
                break;

            case "CREATE_OK_WEB":
                this.props.createLive({
                    chatRoomSeq: this.props.performChatRoomInfo.chatRoomSeq,
                    teacherSeq: this.props.userSeq,
                    liveName,
                    liveCode,
                    mode: "web"
                });
                break;

            case "STOP_LIVE":
                this.props.stopLive({
                    userSeq: this.props.userSeq
                });
                break;

            case "ONAIR":
                // 260804 자동 대기 중 수동 ONAIR를 누르면 타이머 경로의 중복 실행을 막는다.
                this.props.clearPendingAutoOnAir();

                if (liveName.length > 8) {
                    liveName = liveName.substring(0, 6) + "...";
                }

                if (this.props.connectedStudioInfo === null) {
                    this.props.onAirLive({
                        selectedFunc,
                        liveSeq,
                        userSeq: this.props.userSeq,
                        userNickname: this.props.userNickname,
                        liveTeacherNickname: this.props.selectedContentTeacher ? this.props.selectedContentTeacher.contentTeacherNickname : null,
                        mode: "hiclass",
                        groupLimit,
                        msgText: "\uD074\uB798\uC2A4[" + liveName + "] ON",
                        isChattingLock: this.props.isChattingLock,
                        isTouchScreenLock: this.props.isTouchScreenLock
                    });
                } else {
                    this.props.onAirLive({
                        selectedFunc,
                        liveSeq,
                        userSeq: this.props.userSeq,
                        userNickname: this.props.userNickname,
                        liveTeacherNickname: this.props.selectedContentTeacher ? this.props.selectedContentTeacher.contentTeacherNickname : null,
                        mode: "hiclass",
                        groupLimit,
                        msgText: "\uD074\uB798\uC2A4[" + liveName + "] ON",
                        studioSeq: this.props.connectedStudioInfo.studioSeq,
                        isChattingLock: this.props.isChattingLock,
                        isTouchScreenLock: this.props.isTouchScreenLock
                    });
                }

                initializeTimer(liveSeq, list_broadcast);
                break;

            case "OFFAIR_TOGGLE":
                this.props.toggle_offAirBroadcastLive({ selectedFunc, liveSeq });
                break;

            case "OFFAIR":
                if (liveName.length > 8) {
                    liveName = liveName.substring(0, 6) + "...";
                }

                if (this.props.serverUserSeq >= 0) {
                    this.props.offTheAirLive({
                        selectedFunc,
                        liveSeq,
                        userSeq: this.props.userSeq,
                        serverUserSeq: this.props.serverUserSeq,
                        // 260909 mixed 가 켜져 있으면 여기서 stop 이 나간다 (통지 82 §4) ... by hjkim
                        localServerSeq: this.props.localServerSeq,
                        mode: "hiclass",
                        msgText: "\uD074\uB798\uC2A4[" + liveName + "] OFF"
                    });
                } else {
                    this.props.offTheAirLive({
                        selectedFunc,
                        liveSeq,
                        userSeq: this.props.userSeq,
                        mode: "hiclass",
                        msgText: "\uD074\uB798\uC2A4[" + liveName + "] OFF"
                    });
                }
                cancelTimer(liveSeq);
                break;

            case "OPEN_GROUP_STUDY_WINDOW":
                this.props.openGroupStudyWindow({
                    userSeq: this.props.userSeq
                });
                break;

            case "CLOSE_GROUP_STUDY_WINDOW":
                this.props.closeGroupStudyWindow({
                    userSeq: this.props.userSeq
                });
                break;

            case "OPEN_HANDS_UP_WINDOW":
            case "CLOSE_HANDS_UP_WINDOW":
                this.props.handsupOpenToggle({
                    userSeq: this.props.userSeq
                });
                break;

            case "SELECT_ACTIVE_LIVE":
                if (this.props.connectedStudioInfo === null) {
                    this.props.activeHandsUp({
                        liveSeq,
                        userSeq: this.props.userSeq,
                        groupLimit,
                        activeYN: "Y"
                    });
                } else {
                    this.props.activeHandsUp({
                        liveSeq,
                        userSeq: this.props.userSeq,
                        studioSeq: this.props.connectedStudioInfo.studioSeq,
                        groupLimit,
                        activeYN: "Y"
                    });
                }
                break;

            case "UNSELECT_ACTIVE_LIVE":
                if (this.props.connectedStudioInfo === null) {
                    this.props.inactiveHandsUp({
                        liveSeq,
                        userSeq: this.props.userSeq,
                        activeYN: "N"
                    });
                    this.props.closeGroupChatPopup();
                    this.props.clearGroupChat();
                } else {
                    this.props.inactiveHandsUp({
                        liveSeq,
                        userSeq: this.props.userSeq,
                        studioSeq: this.props.connectedStudioInfo.studioSeq,
                        activeYN: "N"
                    });
                }
                break;

            case "MEMBER":
                this.props.toggle_showBroadcastLiveMember({
                    selectedFunc,
                    liveSeq,
                    liveName,
                    list_member
                });
                break;

            case "MEMBER_ACCEPT":
                this.props.updateLiveMember({
                    liveSeq,
                    userSeq: memberSeq,
                    liveCertiYN: "Y",
                    mode: "hiclass"
                });
                break;

            case "MEMBER_ACCEPT_WEB":
                this.props.updateLiveMember({
                    liveSeq,
                    userSeq: memberSeq,
                    liveCertiYN: "Y",
                    mode: "web"
                });
                break;

            case "MEMBER_REJECT_WEB":
                this.props.updateLiveMember({
                    liveSeq: liveSeq,
                    userSeq: memberSeq,
                    liveCertiYN: "R",
                    mode: "web"
                });
                break;

            case "TOGGLE_CERTIFIED_CODE":
                this.props.changeFalseToCertifiedLiveCode({ mode: "hiclass" });
                break;

            case "TOGGLE_CERTIFIED_CODE_WEB":
                this.props.changeFalseToCertifiedLiveCode({ mode: "web" });
                break;

            case "REQUEST_CON":
                this.props.callRequestAssignUser({
                    studioSeq,
                    userSeq: this.props.userSeq
                });
                break;

            case "CANCEL_REQUEST":
                this.props.callCancelRequestAssignUser({
                    studioSeq,
                    userSeq: this.props.userSeq
                });
                break;

            case "CLEAR_ASSIGN":
                if (this.props.list_live && this.props.list_live.length > 0) {
                    const list_onAirLive = this.props.list_live.filter(info => info.liveStatus === "Y");
                    if (list_onAirLive && list_onAirLive.length > 0) {
                        let list_onAirLiveSeq = list_onAirLive.map(row => {
                            return row.liveSeq
                        });
                        this.props.callClearAssignUser({
                            studioSeq,
                            userSeq: this.props.userSeq,
                            list_live: list_onAirLiveSeq
                        });
                    } else {
                        this.props.callClearAssignUser({
                            studioSeq,
                            userSeq: this.props.userSeq,
                            list_live: []
                        });
                    }
                } else {
                    this.props.callClearAssignUser({
                        studioSeq,
                        userSeq: this.props.userSeq,
                        list_live: []
                    });
                }
                break;

            case "UPDATE_GROUP_LIMIT":
                this.props.updateLiveGroupLimit({
                    userSeq: this.props.userSeq,
                    liveSeqArr: liveSeq,
                    groupLimit
                });
                break;

            case "TOGGLE_BROADCAST_NOTIFY":
                this.props.toggleBroadcastTimeNotify({
                    isShowing: false,
                    notifyInfo: {}
                });
                break;

            case "UPDATE_MIXED_CLASS_STATUS":
                data.userSeq = this.props.userSeq;
                data.serverUserSeq = this.props.serverUserSeq;
                data.localServerSeq = this.props.localServerSeq;
                this.props.requestUpdateMixedClassStatus(data);
                break;

            case "ALERT_ERROR_TOGGLE":
                this.props.closeErrorAlertModal();
                break;

            case "MESSAGE":
                this.props.setMessageString(message);
                break;

            default:
                break;
        }
    }

    handleSelectedConfigFunc = ({ selectedFunc, liveSeq, liveName, status, message, publicYn }) => {
        switch (selectedFunc) {
            case "UPDATE_MIXED_EXIST_YN":
                this.props.requestUpdateMixedClassExistYn({
                    selectedFunc,
                    liveSeq,
                    liveName,
                    userSeq: this.props.userSeq,
                    mode: "hiclass",
                    data: { status, serverUserSeq: this.props.serverUserSeq, localServerSeq: this.props.localServerSeq }
                });
                break;

            case "UPDATE_MIXED_LIVE_INFO":
                this.props.updateLiveName({ selectedFunc, liveSeq, liveName, userSeq: this.props.userSeq, mode: "hiclass" });
                break;

            case "UPDATE_PULIC_YN":
                this.props.updatePublicYnForLocalLive({ liveSeq, userSeq: this.props.userSeq, publicYn });
                break;

            case "MESSAGE":
                this.props.setMessageString(message);
                break;

            case "NONE":
                this.props.closeModal(selectedFunc);
                break;

            default:
                break;
        }
    }

    // 20260813 로컬 클래스 설정 모달 안에서만 사용하는 API를 기존 컨테이너가 중계한다.
    getClassMonitorUse = (liveSeq) => {
        return get_class_monitor_use(liveSeq, this.props.userSeq).then(response => response.data);
    }

    updateClassMonitorUse = (liveSeq, classMonitorUseYN) => {
        return update_class_monitor_use(liveSeq, this.props.userSeq, classMonitorUseYN).then(response => response.data);
    }

    renderLocalSettingsModal = () => {
        const { selectedLiveInfo } = this.props;
        if (!this.props.isConfigLocalLiveModalOpened || !selectedLiveInfo || selectedLiveInfo.liveSeq === undefined) {
            return null;
        }

        const modal = (
            <ToppedModal modalClose={this.handleSelectedConfigFunc}>
                <ConfigLocalLive
                    selectedLiveInfo_liveSeq={selectedLiveInfo.liveSeq}
                    selectedLiveInfo_mixedClassExistYn={selectedLiveInfo.mixedClassExistYn}
                    selectedLiveInfo_mixedClassSeq={selectedLiveInfo.mixedClassSeq}
                    selectedLiveInfo={selectedLiveInfo}
                    serverUserSeq={this.props.serverUserSeq}
                    alertKind={this.props.alertKind}
                    alertMessage={this.props.alertMessage}
                    handleSelectedConfigFunc={this.handleSelectedConfigFunc}
                    getClassMonitorUse={this.getClassMonitorUse}
                    updateClassMonitorUse={this.updateClassMonitorUse}
                />
            </ToppedModal>
        );

        return createPortal(modal, document.body);
    }

    render() {
        if (this.props.browserType === enBrowserType.HiClass) {
            if (this.props.isGotoChatting) {
                return <Redirect to="/chatting_hiclass" />;
            } if (this.props.isGotoChatList) {
                return <Redirect to="/list_chat_hiclass" />;
            } else if (this.props.isGotoFriendList) {
                return <Redirect to="/list_friend_hiclass" />;
            }

            return (
                this.props.isConfigLiveListModalOpened === true ?
                    <ConfigMyBroadcastLiveListContainer
                        alertKind={this.props.alertKind}
                        alertMessage={this.props.alertMessage}
                        handleSelectedFunc={this.handleSelectedFunc}
                    /> :
                    <>
                        {this.renderLocalSettingsModal()}
                        {
                            this.props.isOffAirLiveModalOpened &&
                            <CenteredModal modalClose={this.handleSelectedFunc}>
                                <OffAirLive
                                    selectedLiveInfo={this.props.selectedLiveInfo}
                                    handleSelectedFunc={this.handleSelectedFunc}
                                />
                            </CenteredModal>
                        } {
                            this.props.isSearchLiveListModalOpened &&
                            <RightSideModal modalClose={this.handleSelectedFunc}>
                                <SearchLiveList
                                    list_live={this.props.list_live}
                                    list_searchLive={this.props.list_searchLive}
                                    handleSearchValue={this.handleSearchValue}
                                    handleSelectedFunc={this.handleSelectedFunc}
                                />
                            </RightSideModal>
                        } {
                            this.props.isCreateLiveModalOpened &&
                            <ToppedModal modalClose={this.handleSelectedFunc}>
                                <CreateLive
                                    isCertifiedLiveCode={this.props.isCertifiedLiveCode}
                                    createdLiveCode={this.props.createdLiveCode}
                                    alertMessage={this.props.alertMessage}
                                    alertKind={this.props.alertKind}
                                    handleSelectedFunc={this.handleSelectedFunc}
                                />
                            </ToppedModal>
                        } {
                            this.props.isShowLiveMemberModalOpened &&
                            <RightSideModal modalClose={this.handleSelectedFunc}>
                                <BroadcastLiveMember
                                    selectedLiveInfo={this.props.selectedLiveInfo}
                                    handleSelectedFunc={this.handleSelectedFunc}
                                />
                            </RightSideModal>
                        } {
                            this.props.isNotifyLiveBroadcastModalOpened &&
                            <ToppedModal modalClose={this.handleSelectedFunc}>
                                <NotifyLiveBroadcast
                                    list_live={this.props.list_live}
                                    alertMessage={this.props.alertMessage}
                                    alertKind={this.props.alertKind}
                                    handleSelectedFunc={this.handleSelectedFunc}
                                />
                            </ToppedModal>
                        } {
                            this.props.isSendMixedClassLinkModalOpened &&
                            <ToppedModal modalClose={this.handleSelectedFunc}>
                                <SendMixedClassLink
                                    list_live={this.props.list_live}
                                    alertMessage={this.props.alertMessage}
                                    alertKind={this.props.alertKind}
                                    handleSelectedFunc={this.handleSelectedFunc}
                                />
                            </ToppedModal>
                        } {
                            this.props.isErrorAlertModalOpened &&
                            <CenteredModal modalClose={this.handleSelectedFunc}>
                                <AlertErrorModal
                                    alertMessage={this.props.alertMessage}
                                    alertDetailMessage={this.props.alertDetailMessage}
                                    handleSelectedFunc={this.handleSelectedFunc}
                                />
                            </CenteredModal>
                        }
                        <MyBroadcastLiveListContainer
                            browserType={this.props.browserType}
                            selectedFunc={this.props.selectedFunc}
                            handleSelectedFunc={this.handleSelectedFunc}
                        />
                    </>
            );
        } else {
            return (
                <>
                    {this.renderLocalSettingsModal()}
                    <MyBroadcastLiveListContainer
                        routeProps={this.props.routeProps}
                        browserType={this.props.browserType}
                        handleSelectedFunc={this.handleSelectedFunc}
                    />
                </>
            );
        }
    }
}

export default connect(
    ({ chat, live, user, studio }) => ({
        isLoginYn                       : user.isLoginYn,
        userSeq                         : user.userSeq,
        userNickname                    : user.userNickname,
        serverUserSeq                   : user.serverUserSeq,
        localServerSeq                  : user.localServerSeq,
        performChatRoomInfo             : chat.performChatRoomInfo,

        isGotoChatList                  : chat.isGotoChatList,
        isGotoFriendList                : chat.isGotoFriendList,
        isGotoChatting                  : chat.isGotoChatting,
        isGotoLiveList                  : chat.isGotoLiveList,

        selectedLiveInfo                : live.selectedLiveInfo,
        selectedContentTeacher          : live.selectedContentTeacher,

        list_live                       : live.list_live,
        list_searchLive                 : live.list_searchLive,

        isCertifiedLiveCode             : live.isCertifiedLiveCode,
        createdLiveCode                 : live.createdLiveCode,
        alertMessage                    : live.alertMessage,
        alertDetailMessage              : live.alertDetailMessage,
        alertKind                       : live.alertKind,

        selectedFunc                    : live.selectedFunc,

        isNeedInitTimer                 : live.isNeedInitTimer,

        connectedStudioInfo             : studio.connectedStudioInfo,

        isOffAirLiveModalOpened         : live.isOffAirLiveModalOpened,
        isSearchLiveListModalOpened     : live.isSearchLiveListModalOpened,
        isCreateLiveModalOpened         : live.isCreateLiveModalOpened,
        isNotifyLiveBroadcastModalOpened: live.isNotifyLiveBroadcastModalOpened,
        isShowLiveMemberModalOpened     : live.isShowLiveMemberModalOpened,
        isConfigLiveListModalOpened     : live.isConfigLiveListModalOpened,
        isConfigLocalLiveModalOpened    : live.isConfigLocalLiveModalOpened,
        isSendMixedClassLinkModalOpened : live.isSendMixedClassLinkModalOpened,
        isErrorAlertModalOpened         : live.isErrorAlertModalOpened,

        isChattingLock                  : live.isChattingLock,
        isTouchScreenLock               : live.isTouchScreenLock,
    }),
    {
        initGroupChat,
        clearGroupChat,
        closeGroupChatPopup,
        
        checkCode,
        createCode,
        createLive,

        stopLive,
        onAirLive,
        offTheAirLive,
        activeHandsUp,
        inactiveHandsUp,
        joinMyBroadcastLive,

        updateLiveMember,
        updateLiveGroupLimit,
        updateLiveName,
        updatePublicYnForLocalLive,
        requestUpdateMixedClassExistYn,

        notifyLiveBroadcast,
        notifyLiveBroadcastWithGuest,

        getMixedClassMailInfo,
        requestUpdateMixedClassStatus,

        handsupOpenToggle,
        openGroupStudyWindow,
        closeGroupStudyWindow,

        changeFalseToGotoLiveList,
        changeFalseToCertifiedLiveCode,

        searchLiveListResult,
        setMessageString,
        clearPendingAutoOnAir,

        callRequestAssignUser,
        callCancelRequestAssignUser,
        callClearAssignUser,

        closeModal,
        closeErrorAlertModal,
        flaseToInitTimer,
        falseToCertifiedLiveCode,

        toggleBroadcastTimeNotify,
        toggle_sendMixedClassLink,
        toggle_createBroadcastLive,
        toggle_notifyLiveBroadcast,
        toggle_offAirBroadcastLive,
        toggle_showBroadcastLiveMember,
        toggle_configBroadcastLiveList,
        toggle_configLocalBroadcastLive,
        toggle_searchBroadcastLiveList,
    }
)(BroadcastLiveListContainer);
